




import { useEffect } from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateYukData } from "../../../../../features/addLoad/addLoadSlice"
import { useSelector } from "react-redux"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YetkiliNameInput = ({item, data, setData, keyData, name, labelText}) => {

    const handleChange = (e) => {
        const value = e.target.value

        const updatedList = data.map((routeItem) => {
            if(routeItem.id === item.id){
                return {...item, [keyData]: value}
            }
            else{
                return routeItem
            }
        })
        setData(updatedList)
    }

  return (
    <Container value={item.routePointPersonName} radius={"5px"}>
        <input type="text" id={"text"} onChange={handleChange} value={item.routePointPersonName} name={name}/>
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default YetkiliNameInput